const Path = Object.freeze({
  GENERIC: "/partnership/account",
  BASE: "/partnership",
  ACCOUNT: "account",
  CONTACT: "contact",
  REQUEST: "request",
});

export { Path };
